export function getDistinctPoints(points)
{
    return points.filter((point, index, self) => self.findIndex(p => p.latitude === point.latitude && p.longitude === point.longitude) === index);
}